import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ac0c9ec4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  style: {"width":"100%"},
  class: "d-flex flex-column align-center"
}
const _hoisted_2 = {
  key: 2,
  class: "overflow-hidden",
  style: {"height":"100%","width":"100%"}
}
const _hoisted_3 = {
  class: "d-flex pa-5 align-end flex-wrap",
  style: {"gap":"10px"}
}
const _hoisted_4 = { class: "d-flex flex-column" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "org-id" }, "Организации (id)", -1))
const _hoisted_6 = { class: "d-flex flex-column" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "date-start" }, "Начало осмотра", -1))
const _hoisted_8 = { class: "d-flex flex-column" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "date-end" }, "Конец осмотра", -1))
const _hoisted_10 = { class: "d-flex flex-column" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "host-ids" }, "ПАКи (id)", -1))
const _hoisted_12 = { class: "d-flex flex-column" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "types" }, "Тип осмотра", -1))
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "d-flex flex-column" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "employee-id" }, "Работники (id)", -1))
const _hoisted_17 = { class: "d-flex flex-column" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "licenses" }, "Лицензия", -1))
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["href"]
const _hoisted_21 = { key: 1 }

import { ref, computed, onMounted } from 'vue';
import { entity } from './entity.js'
import router from '@/router';
import { useRoute } from 'vue-router';
import {getList, getReport} from "@/services/canceled.service";
import {useAuthStore} from "@/store/auth";


export default /*#__PURE__*/_defineComponent({
  __name: 'list',
  setup(__props) {

const INSPECTION_TYPES = [
  { value: 'BEFORE_TRIP', label: 'Предрейсовый'},
  { value: 'BEFORE_SHIFT', label: 'Предсменный'},
  { value: 'LINE', label: 'Линейный'},
  { value: 'AFTER_TRIP', label: 'Послерейсовый'},
  { value: 'AFTER_SHIFT', label: 'Послесменный'},
  { value: 'PIROMETRY', label: 'Пирометрия'},
  { value: 'PREVENTION', label: 'Профилактика'},
  { value: 'ALCOTESTING', label: 'Алкотестирование'},
]

const route = useRoute();
const authStore = useAuthStore();

const data = ref([]);
const loading = ref(false);
const error = ref(false);
const limit = ref(200);
const page = ref(1);
const total = ref(0);
const downloading = ref(false);

const filterQuery = ref({
  orgIds: null,
  dateStart: null,
  dateEnd: null,
  hostIds: null,
  types: null,
  employeeIds: null,
  licenses: null,
})

const showPagination = computed(() => !loading.value && total.value / limit.value > 1);
const totalPages = computed(() => total.value ? Math.ceil(total.value / limit.value) : 0);

const prepareQuery = (query) => {
  return {
    ...query,
    types: query.types?.join(',') || null
  }
}

const decodeQuery = (query) => {
  return {
    ...query,
    types: query.types?.split(',') || null,
  }
}

const updateRoute = async (query) => {
  const filteredQueries = Object.keys(query).reduce(
      (agg = {}, key) => {
        // Убираем пустые строки и null
        if (query[key] === null || query[key] === '')
          return agg;

        agg[key] = query[key];
        return agg;
      },
      {},
  );

  return router
      .push({ name: route.name, query: filteredQueries })
      .catch(() => {});
};

const fetchList = () => {
  const queryParams: any = {}
  Object.keys(filterQuery.value).forEach(e => {
    if (filterQuery.value[e as keyof typeof filterQuery.value]) {
      queryParams[e] = filterQuery.value[e as keyof typeof filterQuery.value]
      if (e === 'dateEnd') {
        queryParams[e] = queryParams[e] + 'T23:59:59.999'
      }
    }
  })
  const query = prepareQuery(filterQuery.value);
  loading.value = true;
  error.value = false;
  updateRoute(query);
  getList({
    page: page.value,
    limit: limit.value,
    ...queryParams,
  })
      .then(res => res.data)
      .then(responce => {
    data.value = responce.items;
    total.value = responce.total;
  }).catch(() => error.value = true).finally(() => {
    loading.value = false;
  });
}

const download = () => {
  const queryParams: any = {}
  Object.keys(filterQuery.value).forEach(e => {
    if (filterQuery.value[e as keyof typeof filterQuery.value]) {
      queryParams[e] = filterQuery.value[e as keyof typeof filterQuery.value]
      if (e === 'dateEnd') {
        queryParams[e] = queryParams[e] + 'T23:59:59.999'
      }
    }
  })
  downloading.value = true
  getReport({
    page: page.value,
    limit: limit.value,
    ...queryParams,
  })
      .then(res => res.data)
      .then(response => {
        const anchor = document.createElement('a');
        anchor.href = response.s3Key;
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
  }).catch((e) => {
    console.error(e)
  }).finally(() => downloading.value = false);
}
const goToItem = (id) => {
  router.push({ name: 'item', params: { id }})
}
const changePagination = (p) => {
  page.value = p;
  fetchList();
}
const clearFilter = () => {
  filterQuery.value = {
    orgIds: null,
    dateStart: null,
    dateEnd: null,
    hostIds: null,
    types: null,
    employeeIds: null,
    licenses: null,
  };
  fetchList();
}

onMounted(() => {
  filterQuery.value = decodeQuery(route.query);
  fetchList();
})

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_pagination = _resolveComponent("v-pagination")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (loading.value)
        ? (_openBlock(), _createBlock(_component_v_progress_circular, {
            key: 0,
            indeterminate: "",
            size: 70
          }))
        : (error.value)
          ? (_openBlock(), _createBlock(_component_v_alert, {
              key: 1,
              type: "error",
              icon: false
            }, {
              default: _withCtx(() => [
                _createTextVNode("Произошла ошибка загрузки данных "),
                _createVNode(_component_v_btn, {
                  onClick: _unref(authStore).logout
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Завершить сессию")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filterQuery.value.orgIds) = $event)),
                    id: "org-id",
                    class: "border"
                  }, null, 512), [
                    [_vModelText, filterQuery.value.orgIds]
                  ])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filterQuery.value.dateStart) = $event)),
                    type: "date",
                    id: "date-start",
                    class: "border"
                  }, null, 512), [
                    [_vModelText, filterQuery.value.dateStart]
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filterQuery.value.dateEnd) = $event)),
                    type: "date",
                    id: "date-end",
                    class: "border"
                  }, null, 512), [
                    [_vModelText, filterQuery.value.dateEnd]
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filterQuery.value.hostIds) = $event)),
                    id: "host-ids",
                    class: "border"
                  }, null, 512), [
                    [_vModelText, filterQuery.value.hostIds]
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filterQuery.value.types) = $event)),
                    id: "types",
                    class: "border",
                    multiple: ""
                  }, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(INSPECTION_TYPES, (item) => {
                      return _createElementVNode("option", {
                        value: item.value
                      }, _toDisplayString(item.label), 9, _hoisted_14)
                    }), 64))
                  ], 512), [
                    [_vModelSelect, filterQuery.value.types]
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filterQuery.value.employeeIds) = $event)),
                    id: "employee-id",
                    class: "border"
                  }, null, 512), [
                    [_vModelText, filterQuery.value.employeeIds]
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((filterQuery.value.licenses) = $event)),
                    id: "licenses",
                    class: "border"
                  }, null, 512), [
                    [_vModelText, filterQuery.value.licenses]
                  ])
                ]),
                _createVNode(_component_v_btn, {
                  color: "primary",
                  onClick: fetchList
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Применить")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_btn, { onClick: clearFilter }, {
                  default: _withCtx(() => [
                    _createTextVNode("Сбросить")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  class: "bg-green",
                  onClick: download
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Экспортировать")
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_v_table, { dense: "" }, {
                default: _withCtx(() => [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(entity), (header) => {
                        return (_openBlock(), _createElementBlock("th", {
                          key: header.key
                        }, _toDisplayString(header.label), 1))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item, i) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        class: "list-row",
                        onClick: ($event: any) => (goToItem(item.inspectionId))
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(entity), (col) => {
                          return (_openBlock(), _createElementBlock("td", {
                            key: col.key
                          }, [
                            (col.key === 'videoS3Key')
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  href: item[col.key]
                                }, _toDisplayString(item[col.key] ? 'ссылка' : '-'), 9, _hoisted_20))
                              : (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(col.convert ? col.convert(item) : item[col.key] ?? '-'), 1))
                          ]))
                        }), 128))
                      ], 8, _hoisted_19))
                    }), 256))
                  ])
                ]),
                _: 1
              }),
              _withDirectives(_createVNode(_component_v_pagination, {
                modelValue: page.value,
                "onUpdate:modelValue": [
                  _cache[7] || (_cache[7] = ($event: any) => ((page).value = $event)),
                  changePagination
                ],
                length: totalPages.value,
                totalVisible: "10"
              }, null, 8, ["modelValue", "length"]), [
                [_vShow, showPagination.value]
              ])
            ]))
    ]),
    _createVNode(_component_v_dialog, {
      modelValue: downloading.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((downloading).value = $event)),
      scrim: false,
      persistent: "",
      width: "auto"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { color: "primary" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createTextVNode(" Загрузка файла "),
                _createVNode(_component_v_progress_linear, {
                  indeterminate: "",
                  color: "white",
                  class: "mb-0"
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})